import React, { useCallback, useEffect, useState } from 'react'
import { SharedContent } from 'src/models/SharedContent'
import { sharedAppStateStore } from 'src/store/AppStateStore'
import { FormHeaderText, Loader } from 'src/components/Common'
import { SharedContentTable } from 'src/components/Feed/SharedContentTable'
import { TablePaginationConfig } from 'antd/es/table/interface'

const DEFAULT_PAGE_SIZE = 5

export type SharedLinkModalProps = {
  apiQueryParams: object
  heading: string
}

export const SharedLinkModal = ({ apiQueryParams, heading }: SharedLinkModalProps) => {
  const [sharedLinks, setSharedLinks] = useState([])
  const [loading, setLoading] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)

  const getSharedLinks = useCallback(async () => {
    try {
      setLoading(true)
      const { data, count } = await SharedContent.list({
        ...apiQueryParams,
        page: currentPage,
        page_size: DEFAULT_PAGE_SIZE,
      })
      setSharedLinks(data)
      setTotalCount(count)
    } catch (err) {
      sharedAppStateStore.handleError(err)
    } finally {
      setLoading(false)
    }
  }, [apiQueryParams, currentPage])

  useEffect(() => {
    getSharedLinks()
  }, [getSharedLinks])

  const handlePaginate = (page: number, pageSize: number) => {
    setCurrentPage(page)
  }

  const paginationSettings: TablePaginationConfig = {
    showSizeChanger: false,
    pageSize: DEFAULT_PAGE_SIZE,
    onChange: handlePaginate,
    showTotal: (total: number, range: number[]) => `${range[0]}-${range[1]} of ${total} items`,
    total: totalCount,
    current: currentPage,
    simple: sharedAppStateStore.isMobile,
  }

  return (
    <>
      <FormHeaderText heading={heading} />
      {sharedLinks.length > 0 ? (
        <SharedContentTable
          showContentTitle
          existingLinks={sharedLinks}
          loading={loading}
          paginationSetting={paginationSettings}
        />
      ) : loading ? (
        <Loader />
      ) : null}
    </>
  )
}
